/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState, forwardRef, useImperativeHandle, useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Grid from '@mui/material/Grid';
import { Autocomplete, TextField, FormControl, MenuItem } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers';
import { useSelector } from 'react-redux';
import type { RootState } from '../types/types';
import { getAlltemplate } from 'src/services/templateService';
import { getBulkCampaignEndDate } from 'src/services/bulkEmailServices';
import moment from 'moment';
import { HugeiconsIcon } from '@hugeicons/react';
// @ts-ignore
import { AddCircleStrokeRounded, Delete02Icon, ViewStrokeRounded, Image03Icon, ArrowDown01Icon, HelpCircleIcon, Clock01Icon } from '@hugeicons-pro/core-stroke-rounded';
import TemplatePreview from '../TemplatePreview/TemplatePreview';
import CustomTooltip from '../CustomTooltip/CustomTooltip';

import { BULKCAMPAIGN_RESEND_DATE_MESSAGE, RESENDTOOPTIONS, BULK_UNSUBSCRIBE_LEVELS, PRIORITY_OPTIONS, BULK_CAMPAIGN_NAME_TOOLTIP_MESSAGE } from 'src/constants/constant';
import ReactGanttPopup from './GanttChart/BulkEmailGanttPopup';
import InputAdornment from '@mui/material/InputAdornment';


export interface NewBulkEmailCampaignInputs {
  clientId?: number;
  templateId: string;
  templateName?: string;
  name: string;
  startDateTime: string;
  resendMaxLimit?: number;
  createdBy?: number;
  resendSchedules?: any[];
  templateVersion?: number;
  templateIdentifier?: string;
  templateContent?: string;
  unsubscribeTypeId?: string;
  priority: string;
  seedListName?: string;
  suppressionListName?: string;
}

interface ResendSchedule {
  id: string;
  dateTime: moment.Moment | null;
  resendTo: string;
}

interface TemplateListPropType {
  id: number;
  templateName: string;
  templateContent: string;
  templateIdentifier?: string;
  subjectLine: string;
  fromName: string;
  fromEmail: string;
  preheader: string;
  resendSubjectLine: string;
  resendPreheader: string;
  status: number;
  templateVersion: number;
}

interface TemplateApiResponse {
  status: number;
  data: {
    data: TemplateListPropType[];
    result: number;
  };
}

export interface AddNewBulkEmailFormRef {
  getFormData: () => Promise<NewBulkEmailCampaignInputs | null>;
  validateForm: () => Promise<boolean>;
}

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Please enter the campaign name'),
  startDateTime: Yup.string().required('Please enter the campaign start date'),
  templateId: Yup.string().required('Please select email template'),
  // unsubscribeTypeId: Yup.string().required("Please select unsubscribe level"),
  priority: Yup.string().required("Please select priority"),
});
/// date time picker ui 
const digitalClockSelectedStyle = {
  '&.Mui-selected': {
    backgroundColor: '#F13139 !important',
    color: 'white !important',
    fontWeight: '400',
    fontSize: '0.75rem',
    borderRadius: '10px',
  },
  '&.Mui-selected:hover': {
    backgroundColor: '#F13139 !important',
    borderRadius: '10px',
    fontWeight: '400',
    fontSize: '0.75rem',
  },
  '&.Mui-selected:focus': {
    backgroundColor: '#F13139 !important',
    color: 'white !important',
    borderRadius: '10px',
    fontWeight: '400',
    fontSize: '0.75rem',
  }
};
const AddNewBulkEmailForm = forwardRef<AddNewBulkEmailFormRef, { bulkCampaignTotalCount: number;initialData?: NewBulkEmailCampaignInputs | null }>((props, ref) => {
  const [emailTemplates, setEmailTemplates] = useState<TemplateListPropType[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<TemplateListPropType | null>(null);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [resendSchedules, setResendSchedules] = useState<ResendSchedule[]>([]);
  const [estimatedEndDate, setEstimatedEndDate] = useState<any | null>(null);
 const [campaignScheduleModal, setCampaignScheduleModal] = useState(false);
  const storedAppConfig = localStorage.getItem('appConfigs');
  const parsedAppConfig = storedAppConfig ? JSON.parse(storedAppConfig) : [];
  const TemplateImagePublicURL = parsedAppConfig.find((item: any) => item.configName === 'TemplateImagePublicURL')?.configValue;
  const ResendMaxValue: any = parsedAppConfig.find((item: any) => item.configType === "BulkCampaign" && item.configName === "ResendMaxValue")?.configValue;
const [imageError, setImageError] = useState(false);
  const { user } = useSelector((state: RootState) => state.auth);
const [resendErrors, setResendErrors] = useState<{ id: string; message: string | null }[]>([]);

  const { control, getValues, trigger, watch, formState: { errors } } = useForm<NewBulkEmailCampaignInputs>({
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
    defaultValues: {
      priority: "2",
      ...(props.initialData ?? {}),
    },
  });

  const watchedStartDateTime = watch('startDateTime');
  const watchedPriority = watch('priority');

  // Memoize the calculateEstimateEndDate function to avoid unnecessary recreations
  const calculateEstimateEndDate = useCallback((startDateTime: any, priority: string): void => {
    if (!startDateTime || !user?.clientId || !props.bulkCampaignTotalCount || !priority) {
      setEstimatedEndDate(null);
      return;
    }

      const startDateTimeFORMAT =  startDateTime;
      console.log("start date:", startDateTime);
      console.log("Using ISO string:", startDateTimeFORMAT);
    const data = {
      clientId: user.clientId,
      startDateTime: startDateTimeFORMAT,
      recordsCount: props.bulkCampaignTotalCount,
      priority: parseInt(priority) || 1,
      campaignId: null,
      espConnectionId: user.espConnectionId
    };
//@ts-ignore
    getBulkCampaignEndDate(data)
      .then((res: any) => {
        console.log(res);
        if (res.status === 200 && Array.isArray(res.data?.data)) {
          // ✅ find campaignId: -1
          const targetCampaign = res.data.data.find(
            (c: any) => c.campaignId === -1
          );

          if (targetCampaign?.endDateTime) {
            const endDate =  targetCampaign.endDateTime;            
            //@ts-ignore
            setEstimatedEndDate(endDate);
          } else {
            setEstimatedEndDate(null);
          }
        }      
      })
      .catch((error: any) => {
        console.log('Error: ', error);
        setEstimatedEndDate(null);
      });
  }, [user?.clientId, props.bulkCampaignTotalCount]);

  // Effect for initial load and when dependencies change
  useEffect(() => {
    console.log('Component mounted or dependencies changed');
    // Call calculateEstimateEndDate if we have a start date
    if (watchedStartDateTime && watchedPriority) {
      calculateEstimateEndDate(watchedStartDateTime, watchedPriority);
    }
  }, [calculateEstimateEndDate]);

  // ✅ Trigger API when priority changes, but only if startDateTime already confirmed
  useEffect(() => {
    if (watchedPriority && watchedStartDateTime ) {
      calculateEstimateEndDate(
        watchedStartDateTime,
        watchedPriority
      );
    }
  }, [watchedPriority,  calculateEstimateEndDate]);
  

useEffect(() => {
  setImageError(false);
}, [selectedTemplate?.templateIdentifier]);
  useEffect(() => {
    const ClientId = user?.clientId ?? 0;
    getAlltemplate(ClientId)
      .then((res: TemplateApiResponse) => {
        if (res.status === 200) {
          console.log(res.data.data);
          const templateArr = res.data.data
            .filter((template: any) => template.statusName === 'Approved' && template.isDeleted !== 1)
            .map((template: any) => ({ ...template, Name: template.templateName }))
            .sort((a, b) => a.Name.localeCompare(b.Name));
            console.log(templateArr);
          setEmailTemplates(templateArr);
        }
      })
      .catch((error: any) => console.log('Error: ', error));
  }, [user]);

 useImperativeHandle(ref, () => ({
  getFormData: async () => {
    const isFormValid = await trigger();
    const areResendsValid = validateResendSchedules(resendSchedules, watchedStartDateTime ?? null);
    if (!isFormValid || !areResendsValid) return null;

    const formValues = getValues();
    const formattedResendSchedules = resendSchedules
      .filter((s) => s.dateTime)
      .map((s, index) => ({
        resendOrder: index + 1,
        resendDateTime: s.dateTime?.format('YYYY-MM-DDTHH:mm:ss'),
        resendType: s.resendTo,
      }));

    return {
      ...formValues,
      clientId: user?.clientId ?? 0,
      createdBy: user?.id ?? 0,
      templateName: selectedTemplate?.templateName ?? '',
      resendSchedules: formattedResendSchedules,
      resendMaxLimit: formattedResendSchedules.length,
      templateIdentifier: selectedTemplate?.templateIdentifier ?? '',
      templateVersion: selectedTemplate?.templateVersion ?? 1,
      templateContent: selectedTemplate?.templateContent ?? '',
      estimatedEndDate: estimatedEndDate ? estimatedEndDate : null,
    };
  },
  validateForm: async () => {
    const isFormValid = await trigger();
    const areResendsValid = validateResendSchedules(resendSchedules, watchedStartDateTime ?? null);
    return isFormValid && areResendsValid;
  },
}));


  const addResendSchedule = (): void => {
    if (ResendMaxValue && resendSchedules.length >= Number(ResendMaxValue)) return;
    setResendSchedules([...resendSchedules, { id: `resend_${Date.now()}`, dateTime: null, resendTo: '1' }]);
  };

  const removeResendSchedule = (id: string): void => setResendSchedules(resendSchedules.filter((schedule) => schedule.id !== id));

const updateResendSchedule = (
  id: string,
  field: "dateTime" | "resendTo",
  value: any
): void => {
  const updated = resendSchedules.map((s) => {
    if (s.id === id) {
      if (field === "dateTime") {
        // Just store the Moment object directly, don't format it as string
        return { ...s, dateTime: value };
      }
      return { ...s, [field]: value };
    }
    return s;
  });

  setResendSchedules(updated);
  validateResendSchedules(updated, watchedStartDateTime ?? null);
};

  console.log(ResendMaxValue);
useEffect(() => {
  if (props.initialData) {
    if (props.initialData.templateId) {
      const template = emailTemplates.find(t => String(t.id) === String(props.initialData?.templateId));
      if (template) setSelectedTemplate(template);
    }
    if (props.initialData.resendSchedules) {
      setResendSchedules(props.initialData.resendSchedules.map((s, idx) => ({
        id: `resend_${idx}`,
        dateTime: moment(s.resendDateTime),
        resendTo: s.resendType,
      })));
    }
  }
}, [props.initialData, emailTemplates]);
// Updated validateResendSchedules function for AddNewBulkEmailForm
const validateResendSchedules = (schedules: ResendSchedule[], startDate: string | null): boolean => {
  const errors: { id: string; message: string | null }[] = [];
  const usedDates = new Set<string>(); // Track used dates (without time)

  schedules.forEach((s) => {
    let error: string | null = null;

    if (!s.dateTime) {
      error = "Please enter the resend date";
    } else {
      const resendDate = moment(s.dateTime);
      
      // Check if resend date is same as or before start date (date only comparison)
      if (startDate) {
        const startDateMoment = moment(startDate);
        const endDateMoment = moment(resendDate);        
        // Compare only dates, not time
        if (endDateMoment.format('YYYY-MM-DD') <= startDateMoment.format('YYYY-MM-DD')) {
          error = "Resend date must be later than the campaign start date.";
        }
      }
      
      // Check for duplicate dates (date only, ignore time)
      if (!error) {
        const dateOnly = resendDate.format('YYYY-MM-DD');
        if (usedDates.has(dateOnly)) {
          error = "Duplicate resend date is not allowed";
        } else {
          usedDates.add(dateOnly);
        }
      }
    }

    errors.push({ id: s.id, message: error });
  });

  setResendErrors(errors);
  return errors.every((e) => !e.message); // returns true if all are valid
};
useEffect(() => {
  if (resendSchedules.length > 0) {
    validateResendSchedules(resendSchedules, watchedStartDateTime ?? null);
  }
}, [watchedStartDateTime, resendSchedules]);
 const handleCampaignSchedule = () : void=> {
        setCampaignScheduleModal(true);
        // navigate('/bulk-email/schedule');
      }
  return (
    <div className="flex flex-row justify-start">
      <div className="flex justify-between items-center w-full">
        <Grid container spacing={2}>
          <Grid item xs={8} sx={{ paddingRight: '20px' }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <div className="pt-[20px]">
                <form>
                  {/* Campaign Name */}
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <div className="mb-[30px]">
                        <Controller
                          name="name"
                          control={control}
                          render={({ field }) => (
                            <>
                              <TextField {...field} fullWidth autoComplete="off" label="Campaign Name*" error={!!errors.name} 
                              InputProps={{
                                    endAdornment: (
                                        <CustomTooltip title={BULK_CAMPAIGN_NAME_TOOLTIP_MESSAGE} placement="top" arrow>
                                            <InputAdornment position="end" >

                                                <HugeiconsIcon
                                                    icon={HelpCircleIcon}
                                                    size={18}
                                                    color="#3A3A3A"
                                                    strokeWidth={0.2}
                                                />

                                            </InputAdornment>
                                        </CustomTooltip >
                                    ),
                                }}/>
                              {errors.name && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />{errors.name?.message}</div>}
                            </>
                          )}
                        />
                      </div>
                    </Grid>
                  </Grid>

                  {/* Template */}
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <div className="mb-[30px]">
                        <Controller
                          name="templateId"
                          control={control}
                          render={({ field }) => (
                            <>
                              <Autocomplete
                                options={emailTemplates}
                                value={emailTemplates.find((t) => String(t.id) === String(field.value))}
                                getOptionLabel={(option) => option.templateName}
                                disableClearable
                                popupIcon={<HugeiconsIcon icon={ArrowDown01Icon} size={18} color="#3A3A3A" strokeWidth={0.5} />}
                                onChange={(_, value) => {
                                  field.onChange(value ? String(value.id) : '');
                                  setSelectedTemplate(value ?? null);
                                }}
                                renderInput={(params) => <TextField {...params} label="Email Template*" error={!!errors.templateId} />}
                              />
                              {errors.templateId && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="template" width={12} height={12} className="mr-1" />{errors.templateId?.message}</div>}
                            </>
                          )}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  {/* Unsubscribe Level
                  <Grid container spacing={2}>
                      <Grid item xs={12}>
                          <div className="mb-[30px]">
                          <Controller
                              name="unsubscribeTypeId"
                              control={control}
                              defaultValue=""
                              render={({ field }) => (
                              <Autocomplete
                                  options={BULK_UNSUBSCRIBE_LEVELS}
                                  getOptionLabel={(option: any) => option.label} 
                                  popupIcon={
                                  <HugeiconsIcon
                                      icon={ArrowDown01Icon}
                                      size={18}
                                      color="#3A3A3A"
                                      strokeWidth={0.5}
                                  />
                                  }
                                  
                                  isOptionEqualToValue={(option, value) => option.value === value.value}
                                  value={BULK_UNSUBSCRIBE_LEVELS.find((level) => level.value === field.value) ?? undefined}
                                  onChange={(_, selectedLevel) => {
                                  field.onChange(selectedLevel?.value || ""); 
                                  }}
                                  renderInput={(params) => (
                                  <>
                                      <TextField
                                      {...params}
                                      label="Unsubscribe Level*"
                                      error={Boolean(errors.unsubscribeTypeId)}
                                      />
                                      {errors.unsubscribeTypeId && (
                                      <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                          <img src="/assets/images/attention.svg" alt="error" width={12} height={12} className="mr-1" />{errors.unsubscribeTypeId?.message}
                                      </div>
                                      )}
                                  </>
                                  )}
                                  disableClearable
                              />
                              )}
                          />
                          </div>
                      </Grid>
                  </Grid> */}
                  {/* Priority */}
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <div className="mb-[30px]">
                        <Controller
                          name="priority"
                          control={control}
                          render={({ field }) => (
                            <>
                            <Autocomplete
                                options={PRIORITY_OPTIONS}
                                getOptionLabel={(option: any) => option.label} 
                                popupIcon={
                                <HugeiconsIcon
                                    icon={ArrowDown01Icon}
                                    size={18}
                                    color="#3A3A3A"
                                    strokeWidth={0.5}
                                />
                                }
                                
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                value={PRIORITY_OPTIONS.find((level) => level.value === field.value) ?? undefined}
                                onChange={(_, selectedLevel) => {
                                field.onChange(selectedLevel?.value || ""); 
                                }}
                                renderInput={(params) => (
                                <>
                                    <TextField
                                    {...params}
                                    label="Priority*"
                                    error={Boolean(errors.priority)}
                                    />
                                    {errors.priority && (
                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                        <img src="/assets/images/attention.svg" alt="error" width={12} height={12} className="mr-1" />{errors.priority?.message}
                                    </div>
                                    )}
                                </>
                                )}
                                disableClearable
                            />
                              {errors.priority && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="template" width={12} height={12} className="mr-1" />{errors.priority?.message}</div>}
                            </>
                          )}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  {/* Start & End Dates */}
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <div className="mb-[30px]">
                        <Controller
                          name="startDateTime"
                          control={control}
                          render={({ field }) => (
                            <>
                              <DateTimePicker
                                label="Campaign Start Date Time*"
                                disablePast
                                closeOnSelect={false} 
  onChange={(newValue) => {
    // Only update form field, don't call API yet
    if (newValue && moment.isMoment(newValue)) {
      const formatted = moment(newValue).format("YYYY-MM-DD[T]HH:mm") + ":00.00Z";
      field.onChange(formatted);
    } else if (newValue === null) {
      field.onChange("");
    }
  }}
  onAccept={(acceptedValue) => {
    // Call API only when user clicks OK or closes picker
    if (acceptedValue && moment.isMoment(acceptedValue)) {
      const formatted = moment(acceptedValue).format("YYYY-MM-DD[T]HH:mm") + ":00.00Z";
      field.onChange(formatted);
      
      // 👉 Trigger API only when OK button is pressed or picker closes
      if (props.bulkCampaignTotalCount > 0 && watchedPriority) {
        calculateEstimateEndDate(formatted, watchedPriority);
      }
    }
  }}
                             
                                slotProps={{ textField: { fullWidth: true, error: !!errors.startDateTime }, 
                                digitalClockSectionItem: {
                                      sx: digitalClockSelectedStyle
                                    }  
                                  }}
                              />
                              {errors.startDateTime && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="date" width={12} height={12} className="mr-1" />{errors.startDateTime?.message}</div>}
                            </>
                          )}
                        />
                      </div>
                    </Grid>
                          <Grid item xs={6}>
                      <div className="mb-[30px] flex items-center justify-between">
                        {/* Label + Value */}
                        <div className="flex items-center gap-2 w-3/4">
                          <span className="text-muted font-bold text-[14px]">
                            End Date:
                          </span>
                          <span className="text-muted font-normal text-[14px]">
                             {estimatedEndDate ? new Date(estimatedEndDate)
                              .toLocaleString("en-US", {
                                month: "2-digit",
                                day: "2-digit",
                                year: "numeric",
                                hour: "numeric",
                                minute: "2-digit",
                                hour12: true,
                              })
                              .replace(",", "") : 'N/A'}
                          </span>
                        </div>
                    
                        {/* Clock Icon */}
                        <div
                          className="cursor-pointer flex items-center justify-center rounded-full hover:bg-gray-100 p-1"
                          onClick={handleCampaignSchedule}
                        >
                          <HugeiconsIcon
                            icon={Clock01Icon}
                            size={18}
                            color="#3A3A3A"
                            strokeWidth={0.2}
                          />
                        </div>
                      </div>
                    </Grid>
                    
                  </Grid>

                  {/* Resend Schedules */}
                  {resendSchedules.map((r, idx) =>
                   {
  const errorObj = resendErrors.find((e) => e.id === r.id);
  return  (
                    <div key={r.id} >
                      <Grid container spacing={2} alignItems="flex-start" sx={{ mb: 2 }}>
                        <Grid item xs={6}>
                          <DateTimePicker
                           closeOnSelect={false}
                            label={`Resend ${idx + 1} Date Time*`}
                             value={r.dateTime} 
                          onChange={(v) => updateResendSchedule(r.id, 'dateTime', v ? moment(v) : null)} disablePast 
                          slotProps={{
                             textField: { fullWidth: true, error: !r.dateTime },
                             digitalClockSectionItem: {
                                      sx: digitalClockSelectedStyle
                                    }  
                                 }} />
                          {errorObj?.message && (
                          <div className="flex text-primary ml-1 mt-1 text-md font-normal">
                            <img src="/assets/images/attention.svg" alt="error" width={12} height={12} className="mr-1" />
                            {errorObj.message}
                          </div>
                        )}
                        </Grid>
                        <Grid item xs={5}>
                          <FormControl fullWidth sx={{ '& .MuiFormHelperText-root': { minHeight: 20, mt: 0.5 } }}>
                            <Autocomplete
                              options={RESENDTOOPTIONS}
                              value={RESENDTOOPTIONS.find((opt) => String(opt.value) === String(r.resendTo))}
                              getOptionLabel={(option) => option.label}
                              disableClearable
                              popupIcon={<HugeiconsIcon icon={ArrowDown01Icon} size={18} color="#3A3A3A" strokeWidth={0.5} />}
                              onChange={(_, value) => value && updateResendSchedule(r.id, 'resendTo', String(value.value))}
                              renderInput={(params) => <TextField {...params} label="Resend To" />}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={1} className="flex items-center justify-center">
                          <div className="cursor-pointer flex items-center justify-center w-10 h-10 rounded-full hover:bg-red-50" onClick={() => removeResendSchedule(r.id)}>
                            <HugeiconsIcon icon={Delete02Icon} size={20} color="#dc2626" strokeWidth={0.3} />
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  )})}
                  {(!ResendMaxValue || resendSchedules.length < Number(ResendMaxValue)) && (
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <div className="flex items-center justify-center mb-[20px] cursor-pointer" onClick={addResendSchedule} role="button" tabIndex={0}>
                          <HugeiconsIcon icon={AddCircleStrokeRounded} size={18} color="#3a3a3a" strokeWidth={0.2} className="mr-2" />
                          <span className="flex items-center font-medium text-[#3a3a3a]">
                            <span style={{ textDecoration: 'underline' }}>Add resend schedule</span>
                            <span className="ml-1 italic text-gray-500 text-sm">(optional)</span>
                          </span>
                          <CustomTooltip title={BULKCAMPAIGN_RESEND_DATE_MESSAGE} placement="top" arrow>
                            <span className="ml-2 flex items-center"><HugeiconsIcon icon={HelpCircleIcon} size={18} color="#3a3a3a" strokeWidth={0.2} /></span>
                          </CustomTooltip>
                        </div>
                      </Grid>
                    </Grid>
                  )}
                </form>
              </div>
            </LocalizationProvider>
          </Grid>

          {/* Template Preview Section */}
          <Grid item xs={4} sx={{ paddingLeft: '20px' }}>
            <div className="flex justify-between mb-[5px]">
              <div className="text-16 font-semibold text-muted">Template Preview</div>
            </div>
           <div className="relative flex justify-center items-center h-[375px] border border-[#e6ecf2] rounded-lg overflow-hidden">
      {selectedTemplate?.templateIdentifier ? (
  <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded-lg">
    {!imageError ? (
      <img
        src={`${TemplateImagePublicURL}Template/${selectedTemplate.templateIdentifier}/${selectedTemplate.templateVersion}/Template_Large.png`}
        alt="Template Preview"
        className="w-full h-full object-cover rounded-lg"
        onError={() => setImageError(true)}
      />
    ) : (
      <HugeiconsIcon icon={Image03Icon} size={50} color="#6B7280" />
    )}
  </div>
) : (
  <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded-lg">
    <HugeiconsIcon icon={Image03Icon} size={50} color="#6B7280" />
  </div>
)}
          {/* Hover overlay */}
          <div
            className={`absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 rounded-lg ${
              selectedTemplate?.templateIdentifier ? 'hover:opacity-100 transition-opacity cursor-pointer' : ''
            }`}
            onClick={selectedTemplate?.templateContent ? () => setIsPreviewModalOpen(true) : undefined}
          >
            <HugeiconsIcon
              icon={ViewStrokeRounded}
              size={24}
              color="currentcolor"
              strokeWidth={0.5}
              className={`cursor-pointer text-white ${
                !selectedTemplate?.templateContent ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            />
          </div>
        </div>

            <TemplatePreview isOpen={isPreviewModalOpen} onClose={() => setIsPreviewModalOpen(false)} content={selectedTemplate?.templateContent ?? ''} />
          </Grid>
        </Grid>
      </div>
        <ReactGanttPopup
                open={campaignScheduleModal}
                onClose={() => setCampaignScheduleModal(false)}
              />
    </div>
  );
});

AddNewBulkEmailForm.displayName = 'AddNewBulkEmailForm';
export default AddNewBulkEmailForm;